Element.prototype.parents = function (selector) {
  var elements = [];
  var elem = this;
  var ishaveselector = selector !== undefined;

  while ((elem = elem.parentElement) !== null) {
    if (elem.nodeType !== Node.ELEMENT_NODE) {
      continue;
    }

    if (!ishaveselector || elem.matches(selector)) {
      elements.push(elem);
    }
  }

  return elements;
};

import '../components/boxes/boxes.js'; import '../components/chat/chat.js'; import '../components/fields/fields.js'; import '../components/list/list.js'; import '../components/menu/menu.js'; import '../components/popup/popup.js'; import '../components/profile/profile.js'; import '../components/templates/templates.js'; import '../components/tooltip/tooltip.js';
import svg4everybody from 'svg4everybody';
global.svg4everybody = svg4everybody;
svg4everybody();